import { Button, Divider, Group, List, Loader, Modal, Text, ThemeIcon } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import getErrorMessage from '../../../helpers/getErrorMessage';
import { confirmFor } from '../transitions';
import { SET_LIVE_STEPS } from './setLive';

const StepIcon = ({ state }) => {
  if (state === 'running') return <Loader size={14} />;
  if (state === 'done')
    return (
      <ThemeIcon size={16} radius="xl" color="success">
        <IconCheck size={12} />
      </ThemeIcon>
    );
  if (state === 'failed')
    return (
      <ThemeIcon size={16} radius="xl" color="danger">
        <IconX size={12} />
      </ThemeIcon>
    );
  return <ThemeIcon size={16} radius="xl" color="gray" variant="light" />;
};

// The confirm dialog of Set live; it stays open while the steps run and shows where one stopped.
const SetLiveDialog = ({ instance, run, onClose }) => {
  const [states, setStates] = useState({});
  const [errors, setErrors] = useState({});
  const [running, setRunning] = useState(false);
  const confirm = confirmFor('live', instance);

  const start = async () => {
    setStates({});
    setErrors({});
    setRunning(true);
    const { ok } = await run((id, state, err) => {
      setStates((previous) => ({ ...previous, [id]: state }));
      if (err) setErrors((previous) => ({ ...previous, [id]: getErrorMessage(err, 'This step failed.') }));
    });
    setRunning(false);
    if (ok) onClose();
  };

  return (
    <Modal opened onClose={running ? () => {} : onClose} title="Set live" size="md" centered>
      <Text size="sm">{confirm.body}</Text>
      <List spacing={6} mt="sm" listStyleType="none">
        {SET_LIVE_STEPS.map((step) => (
          <List.Item key={step.id} icon={<StepIcon state={states[step.id]} />}>
            <Text size="sm">{step.label}</Text>
            {errors[step.id] && (
              <Text size="xs" c="danger">
                {errors[step.id]}
              </Text>
            )}
          </List.Item>
        ))}
      </List>
      <Text fz={12} c="dimmed" mt={8}>
        {confirm.note}
      </Text>
      <Divider my="md" />
      <Group justify="flex-end" gap={8}>
        <Button size="sm" variant="default" disabled={running} onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" color="success" loading={running} onClick={start}>
          Set live
        </Button>
      </Group>
    </Modal>
  );
};

export default SetLiveDialog;
